import { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { GET_DURATION } from "../../../Utils/types";
import { staticRangesDatePicker } from "../../../Utils/helper";

const DateRangePickerInput = () => {
  const dispatch = useDispatch();
  const [rangepicker, setRange] = useState([
    {
      startDate: "",
      endDate: "",
      key: "selection",
    },
  ]);
  const [open, setOpen] = useState(false);
  const [isDesktop, setDesktop] = useState(window.innerWidth > 991);
  const refOne = useRef(null);
  const globalReducer = useSelector((state) => state?.globalReducer);

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const updateMedia = () => {
    setDesktop(window.innerWidth > 991);
  };
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  useEffect(() => {
    const startDateFormat = moment(rangepicker[0]?.startDate).format(
      "YYYY-MM-DD"
    );
    const endDateFormat = moment(rangepicker[0]?.endDate).format("YYYY-MM-DD");
    const range = [
      { ...rangepicker[0], startDate: startDateFormat, endDate: endDateFormat },
    ];
    document.addEventListener("click", hideOnClickOutside);
    dispatch({
      type: GET_DURATION,
      payload: range,
    });
  }, [rangepicker[0]?.startDate, rangepicker[0]?.endDate]);
  return (
    <div className="calendarWrap" style={{ cursor: "pointer" }}>
      <div
        id="daterange"
        className="selectbox pull-right"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
      >
        <input
          placeholder="Select Duration Date"
          className="daterangeinput"
          onChange={() => {}}
          value={
            rangepicker[0]?.startDate === "" ||
            globalReducer?.getDuration[0]?.startDate === "Invalid date"
              ? ""
              : `${moment(rangepicker[0]?.startDate).format(
                  "DD/MM/YYYY"
                )} - ${moment(rangepicker[0]?.endDate).format("DD/MM/YYYY")}`
          }
        />
        <i className="fa-solid fa-caret-down"></i>
      </div>

      <div ref={refOne}>
        {open && (
          <DateRangePicker
            onClickOutside={() => setOpen(true)}
            onChange={(item) => {
              setRange([item.selection]);
            }}
            staticRanges={staticRangesDatePicker}
            inputRanges={[]}
            editableDateInputs={true}
            moveRangeOnFirstSelection={false}
            ranges={rangepicker}
            months={2}
            maxDate={new Date()}
            direction={isDesktop ? "horizontal" : "vertical"}
            className="calendarElement"
            showSelectionPreview={true}
          />
        )}
      </div>
    </div>
  );
};

export default DateRangePickerInput;
